import type { LocalDatabaseReceipt } from "../../_Generated/Sync.gen";
import type BaseRepository from "./BaseRepository";

export type ReceiptTypeUnion = LocalDatabaseReceipt["type"];
export type ReceiptServerTypeUnion = "NORMAL" | "TEXT_ONLY" | "A4" | "EMAIL";

export const ReceiptServerToLocalMap: Record<ReceiptServerTypeUnion, ReceiptTypeUnion> = {
    NORMAL   : "receipt-full",
    TEXT_ONLY: "receipt-text",
    A4       : "a4",
    EMAIL    : "email",
};

export const ReceiptLocalToServerMap: Record<ReceiptTypeUnion, ReceiptServerTypeUnion> = {
    "receipt-full": "NORMAL",
    "receipt-text": "TEXT_ONLY",
    "a4"          : "A4",
    "email"       : "EMAIL",
};

export type ReceiptPaddingType = Exclude<LocalDatabaseReceipt["padding"], null>;

export interface BaseReceiptRepository extends BaseRepository<LocalDatabaseReceipt> {
    filter(filter: (item: LocalDatabaseReceipt) => boolean): Promise<Array<LocalDatabaseReceipt>>;
    getByType(type: ReceiptTypeUnion): Promise<Array<LocalDatabaseReceipt>>;
}
